import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class HomeBanner extends Component{
    render(){

        const { sms } = this.props;
        const tselUrl = sms && sms.tsel ? sms.tsel : "#";

        return(
            <>
                <div className="container py-4">
                    <a className="more" href={tselUrl}><span>Ikutan sekarang!</span><span><img src="http://resources.triyakom.com/mini_portal/right-chevron.png" /></span></a>
                </div>
            </>
        );
    }
}

export default HomeBanner;
